export const LANGUAGES = ['ru', 'en'] as const;

export type Language = (typeof LANGUAGES)[number];

export const DEFAULT_LANGUAGE: Language = 'ru';

export const LANGUAGE_NAMES: Record<Language, string> = {
  ru: 'Русский',
  en: 'English',
};

const STORAGE_KEY = 'earworm:language';

const isLanguage = (value: unknown): value is Language => LANGUAGES.includes(value as Language);

const baseOf = (tag: string) => tag.toLowerCase().split('-')[0];

export const detectLanguage = (saved: string | null, preferred: readonly string[]): Language => {
  if (isLanguage(saved)) {
    return saved;
  }
  return preferred.map(baseOf).find(isLanguage) ?? DEFAULT_LANGUAGE;
};

export const readSavedLanguage = () => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const saveLanguage = (language: Language) => {
  try {
    localStorage.setItem(STORAGE_KEY, language);
  } catch {
    return;
  }
};
